module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre11",
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('table', {
    staticClass: "calibre12",
    attrs: {
      "border": "0",
      "cellpadding": "5",
      "cellspacing": "0",
      "summary": "Illustrations"
    }
  }, [_c('colgroup', {
    staticClass: "calibre13"
  }, [_c('col', {
    staticClass: "calibre18"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre14"
  })]), _vm._v(" "), _c('tbody', {
    staticClass: "calibre16"
  }, [_c('tr', {
    staticClass: "calibre17"
  }, [_c('th', {
    staticClass: "calibre19"
  }), _vm._v(" "), _c('th', {
    staticClass: "smfontr"
  }, [_vm._v("PAGE")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdl2"
  }, [_c('div', {
    staticClass: "noi2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0002#i_frontis"
    }
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("“We Taught Those Thar\nRed Demons a Lesson They’ll Not Forget.” ")])]), _c('span', {
    staticClass: "flright1"
  }, [_c('i', {
    staticClass: "calibre9"
  }, [_vm._v("Frontispiece")])])])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdl3"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#i_fp022"
    }
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Christopher Carson")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("22")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdl3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#i_fp071",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("John Charles Frémont")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("71")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdl3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#i_fp104",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("The First Buffalo Had Fallen to the\nCrack of Kit Carson’s Rifle")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("104")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdl3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#i_fp130",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("As the Boat Came Whirling Down,\nHelpless and Inert, Heads Broke Up Around It")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("130")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre17"
  }, [_c('td', {
    staticClass: "tdl3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024#i_fp232",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap1"
  }, [_vm._v("Kit and the Lieutenant Showed the\nThree, by Signs, How from the Rifles and Carbines Could Speed a Bullet and Bore Them Through\nand Through")])])]), _vm._v(" "), _c('td', {
    staticClass: "tdrb"
  }, [_vm._v("232")])])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre8"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00007",
      "title": "[13]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_13",
      "title": "[13]"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0